import { useI18n } from "i18n";
import { useState, useCallback } from "react";
import { Apps } from "@remo-co/ui-core/src/icons/Apps";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Link } from "@remo-co/ui-core/src/components/Link";
import { ClickAwayListener } from "@remo-co/ui-core/src/components/ClickAwayListener";
import { EdcLogoFull } from "@remo-co/ui-core/src/icons/EdcLogoFull";
import { IconButton } from "@remo-co/ui-core/src/components/IconButton";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { EDC_APPS } from "./constants";
import { styles } from "./styles";

export const EdcAppsNavigationButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useI18n(["menu"]);

  const handleClick = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <Box sx={{ position: "relative" }}>
      <IconButton
        data-testid="edc-apps-navigation-button"
        onClick={handleClick}
      >
        <Apps />
      </IconButton>
      {isOpen && (
        <ClickAwayListener onClickAway={handleClick}>
          <Box sx={styles.container}>
            <Typography variant="h4" sx={styles.headerText}>
              {EDC_APPS.TITLE}
            </Typography>
            <Box sx={styles.appsContainer}>
              {EDC_APPS.APPS.map((app) => (
                <Link
                  href={app.link}
                  key={app.id}
                  sx={styles.appItem}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {app.icon}
                  <Box>
                    <Box sx={styles.title}>
                      <Box sx={styles.appIcon}>
                        <EdcLogoFull />
                      </Box>
                      <Typography variant="subtitle1" sx={styles.appTitle}>
                        {app.title}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body1"
                      color="events.grayTertiary"
                      sx={styles.description}
                    >
                      {t(app.description)}
                    </Typography>
                  </Box>
                </Link>
              ))}
            </Box>
          </Box>
        </ClickAwayListener>
      )}
    </Box>
  );
};
